import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { ButtonGroup } from 'legacyComponents/styles';

export const CommentActions = styled(ButtonGroup)`
  padding-top: 10px;
  padding-bottom: ${props => (props.thread ? '20px' : '0px')};
`;

export const Wrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  height: auto;
  display: flex;
`;

export const Main = styled.div`
  /* width is 100% - avatar widht(42) - marginLeft (15) */
  width: ${props => (props.thread ? 'calc(100% - 42px)' : 'calc(100% - 59px)')};
  margin: ${props => (props.thread ? '0px 0px 0px 10px' : '0px 0px 0px 15px')};
  height: auto;
  border: 1px solid ${props => props.theme.color.wfGrey300};
  display: inline-block;
  background-color: ${props => props.theme.color.wfWhite};
  padding: ${props =>
    !props.thread && props.viewMode
      ? '10px 20px 10px 20px'
      : props.thread
      ? '10px 20px 0px 20px'
      : props.viewMode
      ? '10px 30px 0px 30px'
      : '10px 30px 20px 30px'};
  line-height: 1.6;
  color: ${props => props.theme.color.wfGrey};
  &:hover {
    box-shadow: 0 1px 1px rgba(44, 45, 48, 0.07);
  }
  ${media.s`
    width: 100%;
    margin: 20px 0 0 0;
    padding: ${props =>
      props.viewMode ? '5px 10px 0 10px' : '5px 10px 20px 10px'};
  `};
`;

export const Head = styled.div`
  width: 100%;
  padding: 0 0 5px 0;
`;

export const Commentor = styled.p`
  font-size: 0.875em;
  color: ${props => props.theme.color.primary};
  font-weight: 600;
  margin: 0px;
  display: inline-block;
  &:hover {
    text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  }
  ${media.s`
    font-size: 0.8em;
  `};
`;

export const Time = styled.span`
  font-size: 0.875em;
  color: ${props => props.theme.color.wfGrey500};
  margin: 0px;
  font-weight: 400;
  ${media.s`
    font-size: 0.75em;
  `};
`;

export const Edit = styled.span`
  font-size: 0.875em;
  color: ${props => props.theme.color.wfGrey900};
  margin: 0px;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.color.primary};
  }
  ${media.s`
    font-size: 0.75em;
  `};
`;

export const BodyWrapper = styled.div`
  height: auto;
  margin: ${props =>
    props.viewMode ? '0px 0px 0px 0px' : '10px 0px 30px 0px'};
  padding: 10px 5px 10px 5px;
  border: ${props =>
    props.viewMode
      ? 'none'
      : props.focussed
      ? `1px solid ${props.theme.color.wfBlack}`
      : `1px solid ${props.theme.color.wfGrey400}`};
  font-size: 15px;
  position: relative;
  min-height: ${props => (props.viewMode ? '0' : '80px')};
  > div {
    width: 100%;
  }
  ::active {
    border: 1px solid red;
  }
`;

export const DeleteBtn = styled(Edit)`
  &:hover {
    color: ${props => props.theme.color.wfOrange};
  }
`;
